import { render, staticRenderFns } from "./GbfsStream.vue?vue&type=template&id=54f267a7&scoped=true"
import script from "./GbfsStream.vue?vue&type=script&lang=js"
export * from "./GbfsStream.vue?vue&type=script&lang=js"
import style0 from "./GbfsStream.vue?vue&type=style&index=0&id=54f267a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f267a7",
  null
  
)

export default component.exports